import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetCustomerByIdQuery } from "../customerApi";
import Breadcrumb from "../../../components/common/Breadcrumbs";
import BranchForm from "./BranchForm";
import ContactTab from "../branchContact/ContactTab";
import { Tabs } from "react-simple-tabs-component";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useDeleteBranchByBranchIdMutation, useGetBranchByIdQuery } from "../branchApi";
import ModalButton from "../../../components/common/form/ModalButton";
import IconButton from "../../../components/common/form/IconButton";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import AuditableInfoButton from "../../../components/common/form/AuditableInfoButton";

const BranchDetailPage = () => {

    let { customerId } = useParams();
    let { branchId } = useParams();
    const [crumbs, setCrumbs] = useState<any[]>([]);
    const navigate = useNavigate();
    const branchQuery = useGetBranchByIdQuery(branchId ? { branchId } : skipToken);
    const customerQuery = useGetCustomerByIdQuery(customerId ?? skipToken);
    const [deleteApi, { isLoading }] = useDeleteBranchByBranchIdMutation();

    useEffect(() => {
        const branchObj = branchQuery?.data;
        const customerObj = customerQuery?.data;
        if (branchObj && customerObj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Customers", url: "/customers" },
                { content: customerObj?.customerName, url: `/customers/${customerId}` },
                { content: branchObj?.name, url: "" }
            ]);
            document.title = `Branches`;
        }
    }, [branchQuery?.data, customerQuery?.data]);
    // Compute tabs using useMemo
    const tabs = useMemo(() => {
        const result: any[] = [];

        result.push({
            label: 'Contacts',
            Component: ContactTab
        });

        return result;
    }, []);

    const handleDelete = async () => {
        if (branchId) {
            await deleteApi({
                customerId,
                branchId
            }
            ).unwrap();
        }
        navigate(`/customers/${customerId}`)
    };
    return (
        <>
            <div className="px-5 py-5" >
                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs} />
                    <div className={"justify-between sm:block md:flex lg:flex gap-3"}>
                        

                        {hasPermission(["BRAN-D"]) && branchQuery?.data?.defaultBranch === false  &&
                            <ModalButton
                                triggerButton={
                                    <IconButton
                                        icon={<FaTrash />}
                                        title={"Delete Branch"}
                                        hasBackground={true}
                                        className="mr-2"
                                    />
                                }
                                modal={
                                    <ConfirmationModal
                                        show={true}
                                        setShow={() => {
                                        }}
                                        title={"Delete Branch"}
                                        bodyMessage={"Are you sure you want to delete this Branch?"}
                                        onSubmit={() => handleDelete()}
                                        isLoading={isLoading}
                                    />
                                }
                            />
                        }
                        { hasPermission( ["AUDIT-V"]) &&
                            <AuditableInfoButton obj={branchQuery.data} />
                        }

                    </div>
                </div>


                <div className="grid grid-cols-2 mt-3">
                    <div className="bg-text-0 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)] relative">
                        <div className="flex justify-between items-center border-b border-[rgba(0,0,0,0.1)] p-2 ">
                            <h2 className="font-semibold text-surface-0">Branch Detail
                            </h2>
                        </div>

                        <div className={'p-2'}>
                            <BranchForm customerId={customerId} branchId={branchId} btnText='Update'
                                cancelBtnText='Cancel' isEditable={hasPermission(["BRAN-U"])} labelClass={true} />
                        </div>

                    </div>
                    <div className={"ml-3 rounded-md"}>
                        <Tabs tabs={tabs} className="bootstrap-tabs-component" />
                    </div>
                </div>

            </div>

        </>
    )
}
export default BranchDetailPage;